module.exports = __webpack_public_path__ + "static/media/butternut-squash.ef08e2a6.png";